import { gql } from '@apollo/client';

export const UPDATE_CREW_MEMBER_HOLD_DOWN = gql`
	mutation updateCrewMemberHoldDown($id: ID!, $input: CrewMemberHoldDownInput!) {
		updateCrewMemberHoldDown(id: $id, input: $input) {
			... on CrewMemberHoldDownErrorResponse {
				errors {
					code
				}
			}
		}
	}
`;
